module.exports = __webpack_public_path__ + "mjinduchau.png?cb9d1bbb246e1f05e1e0cf4e70f1343d";


//////////////////
// WEBPACK FOOTER
// ./static/assets/mjinduchau.png
// module id = 540
// module chunks = 0